module.exports = __webpack_public_path__ + "img/edge.142ab4b8.svg";